export enum QuestionStatusTypes {
  Active = 1,
  Suspended = 2,
  Deleted = 3,
}
